module.exports = __webpack_public_path__ + "static/media/scanning_pipeline.d6cbcb5d.jpg";